import { Mail, Youtube } from "lucide-react";
import { Link } from "react-router-dom";

const LOGO = `${process.env.PUBLIC_URL}/urzu-logo-white.png`;

const nav = [
  { label: "About", id: "about" },
  { label: "Services", id: "services" },
  { label: "Sectors", id: "sectors" },
  { label: "Partners", id: "partners" },
  { label: "Why Us", id: "why-us" },
  { label: "Contact", id: "contact" },
];

const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-[#0B1B3D] text-slate-300">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid md:grid-cols-3 gap-10">
        <div>
          <div className="inline-block">
            <img src={LOGO} alt="Urzu Media" className="h-14 w-auto" />
          </div>
          <p className="mt-5 text-sm leading-relaxed max-w-xs text-slate-400">
            An integrated media & communications company delivering high-impact PR,
            digital and events services for dialogue, knowledge exchange and stakeholder engagement.
          </p>
        </div>

        <div>
          <h4 className="text-white font-semibold text-sm uppercase tracking-widest">Explore</h4>
          <ul className="mt-5 space-y-3">
            {nav.map((n) => (
              <li key={n.id}>
                <a
                  data-testid={`footer-nav-${n.id}`}
                  href={`/#${n.id}`}
                  className="text-sm text-slate-400 hover:text-[#D91C29] transition-colors"
                >
                  {n.label}
                </a>
              </li>
            ))}
            <li>
              <Link
                data-testid="footer-nav-event"
                to="/event"
                className="text-sm text-slate-400 hover:text-[#D91C29] transition-colors"
              >
                Event
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold text-sm uppercase tracking-widest">Contact</h4>
          <a
            href="mailto:info@urzumedia.com"
            data-testid="footer-email"
            className="mt-5 inline-flex items-center gap-3 text-slate-300 hover:text-[#D91C29] transition-colors"
          >
            <Mail size={18} />
            info@urzumedia.com
          </a>

          <Link
            to="/youtube-stream"
            data-testid="footer-youtube-stream-link"
            className="mt-5 flex items-center gap-3 text-slate-300 hover:text-[#D91C29] transition-colors"
          >
            <Youtube size={18} />
            Youtube Stream
          </Link>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-500">© {new Date().getFullYear()} Urzu Media. All rights reserved.</p>
          <p className="text-xs text-slate-500">PR & Communications · Digital Marketing · Events</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
